// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"HowItWorks__howItWorks__U7wRN","iconWrapper":"HowItWorks__iconWrapper__2MIwb","icon":"HowItWorks__icon__+7OIU"};